var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var InAppMessageController = /** @class */ (function () {
    function InAppMessageController() {
    }
    /*****************************************************************************************************
        * Is using route "api/inappmessages/inbox" and http method "POST" to call the back-end.
    
        * @param {TokenContainer} token
        * @returns {ExtendedDataCollection<InAppMessageDownloadDto, string>}
    ******************************************************************************************************/
    InAppMessageController.GetInAppMessages = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/inappmessages/inbox", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.token
        });
    };
    /*****************************************************************************************************
        * Is using route "api/inappmessages/send" and http method "POST" to call the back-end.
    
        * @param {InAppMessageUploadDto} dto
        * @returns {InAppMessageUploadDto}
    ******************************************************************************************************/
    InAppMessageController.SendInAppMessages = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/inappmessages/send", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/inappmessages/done/{id}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @returns {InAppMessageDownloadDto}
    ******************************************************************************************************/
    InAppMessageController.DoneInAppMessage = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/inappmessages/done/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/inappmessages/unread/{id}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @returns {InAppMessageDownloadDto}
    ******************************************************************************************************/
    InAppMessageController.UnReadInAppMessage = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/inappmessages/unread/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/inappmessages/read/{id}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @returns {InAppMessageDownloadDto}
    ******************************************************************************************************/
    InAppMessageController.ReadInAppMessage = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/inappmessages/read/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/inappmessages/undone/{id}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @returns {InAppMessageDownloadDto}
    ******************************************************************************************************/
    InAppMessageController.UnDoneInAppMessage = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/inappmessages/undone/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/inappmessages/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    InAppMessageController.DeleteInAppMessages = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/inappmessages/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    return InAppMessageController;
}());
export { InAppMessageController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=InAppMessageController.js.map